import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—June 2005" />
	<Old2005BlogPage>
		<h2>June 2005</h2>






		<h3 className="blogdate">
		Friday, June 10, 2005
		</h3>






		<h4 className="blogitemtitle">
		A couple words on La Tropicana Cafe
		</h4>





			<div className="blogitembody">
			I'd just like to mention that La Tropicana is a cool cafe in Fremantle. I dealt mostly with Tim and he is a good dude! The atmosphere, music and food is chill, and I think it's great that they welcome musicians to perform around lunch. At this time they can only pay you with food and coffee, but you can promote yourself while playing for an hour, and I even made some tips today in my guitar case! I also met Pippa Drysdale there who sells CDs while she performs, and she has a website which I will advertise below! And wow, I broke ANOTHER set of strings today.<br /><br />Links:<br /><a href="http://www.pippadrysdale.com">http://www.pippadrysdale.com</a><br /><a href="http://www.latropicanacafe.com.au">http://www.latropicanacafe.com.au</a> (future)
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:52 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Thursday, June 09, 2005
		</h3>






		<h4 className="blogitemtitle">
		My week in Fremantle, WA
		</h4>





			<div className="blogitembody">
			I arrived in Perth after a two week road trip and felt reluctant to be in a city again, so I immediately escaped to the Sundancer Backpacker in Fremantle. It's overall been a laid-back week! This hostel scores a little low on places to relax quietly, however it scores high on social atmosphere, building/facility character, and the people that stay within.<br /><br />I met an Aussie fellow named Tristan that plays guitar and didgiridoo simultaneously, and sings with a strong clear voice in a Bob Marley influenced style. Tristan says "bloody oath" a lot where I might say "absolutely", "fuckin rights", or "that is the truth, I swear." I don't think I say any of those phrases, but whatever. Tristan has dreads, busks from point a to point b, and is unaware that the top and mid sectino of his shirt has buttons. I liked this dude and we may meet up and be musical in Broome or Darwin. We jammed for hours and revealed that many of the laid-back fold staying at the hostel are musicians. It's been a good spot for me.<br /><br />The night scene in Fremantle is not for me; all the potentially cool pubs and cafes become overrun with young try-hards that are destined to mate and marry each other and raise young "try-hard-lings." Good on them. The cool spot to be at night, in my somewhat reclusive opinion, is at the hostel common room (which has a bar), or on a dark beach by the harbour. If you run your hand through the top sand on the beach, some particles glow momentarily... ifsomeone can explain to me this curious beach-sand luminescence, I will be grateful!<br /><br />During the da, Fremantle is a cozy little city/burb with some cool streets and buildings. I went to a cool maritime museum and explored the streets and markets, but that was short lived. I found some excellent huge rocks (part of a jetty or marina harbour) to sit and soak sun on, while reading The Hitchhiker's Guide to the Galaxy, and watching sunsets followed by thunderhead silhouettes over the ocean. Flash rain showers come and go all day at this time of year!<br /><br />Now, I might get my hand slapped by some readers, but I forgot to go visit Rottnest Island. Could the rain possibly have stimulated my glands that secrete anti-remembrance fluid? I don't know. It could be the price of a day's adventure there, too. I'm here for another few days so maybe I'll go... I dunno. I might go into Perth for a day instead and find some camera stores; I am toying with the idea that my camera system is ridiculously large for travelling. However, I just picked up my first two rolls of slides and am reminded of why I want the frustration of this camera... it's all about quality! So I may just get rid of more clothes instead to make more room in my pack. I have less than a week's worth of clothes and have done laundry twice since I left... you do the math. Showering is also quite optional, in my mind.<br /><br />I've met a couple people that feel the same way, so in a few days we will start a camping adventure north and leave this cooler weather behind. This next trip will probably consume the rest of my money so I am trying to imagine how big banana and mango spiders are up north...<br /><br />If anyone is wondering, I have a couple 1 hr gigs this week at Tropicana Cafe; my payment is lunch. I'm not complaining because I get to play and sing, and everything (including food) is ridiculously expensive here. By the way, who wants to send me a shipment of my favorite guitar strings? This stupid ocean air keeps breaking my strings, and they are also on double-the-price-of-Canada special here. I think I have a decent digi pic coming of me playing at Tropicana; if it comes I will post it for Rebecca to drool over. Just kidding, I am posting for Dave to drool over. But Dave always drools, that's his thing. Just kidding. Bloody oath.<br /><br />If you have won a lottery recently, please send me some money. Otherwise, take care for now!!!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:32 AM &nbsp;

			</div>






		<h3 className="blogdate">
		Wednesday, June 08, 2005
		</h3>






		<h4 className="blogitemtitle">
		Jeff Buckley
		</h4>





			<div className="blogitembody">
			Holy shit. I never knew. But I do now. I heard of him, but no one made me listen. Now, while travelling, I have time for anything. I have heard Jeff Buckley. I wish I was part of the Sin-é crowd in the early 90's.<br /><br /><a href="http://www.jeffbuckley.com">http://www.jeffbuckley.com</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:56 AM &nbsp;

			</div>








		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
